import React, { useState, useEffect, useRef } from "react";
import { useMutation, useManualQuery } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { project_url } from "../../constants/Data";

import { GET_TEAM_TERM_BY_ID, EDIT_TEAM_TERM_NOTES } from "../../graphQL/team_term_qry";

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },

  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  textFieldInput: {
    resize: "Vertical",
    height: "200px",
    maxHeight: "200px",
    width: "500px",
    maxWidth: "550px",
  },
}));

export default function EditTeamTermNotesDialog({
  teamTermId,
  // sprintName,
  // notes,
  closeDialog,
  handleDone,
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [teamName, setTeamName] = useState("");
  const [termName, setTermName] = useState("");
  const [initNotes, setInitNotes] = useState("");
  const [currentNotes, setCurrentNotes] = useState("");

  const [getTeamTermDataQuery] = useManualQuery(GET_TEAM_TERM_BY_ID);
  const getTeamTermData = async () => {
    const { loading, error, data } = await getTeamTermDataQuery({
      variables: {
        teamTermId: parseInt(teamTermId),
      },
    });
    if (!loading && data && data.getTeamTermDataById) {
      setTeamName(data.getTeamTermDataById.teamId.name);
      setTermName(data.getTeamTermDataById.termId.name);
      setCurrentNotes(data.getTeamTermDataById.note);
      setInitNotes(data.getTeamTermDataById.note);
    }
    if (error) {
      // if (termsListError.graphQLErrors[0].message === "Signature has expired")
      navigate(`${project_url}/signin`);
    }
  };

  useEffect(() => {
    (() => getTeamTermData())();
  }, []);

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleChange = event => {
    setCurrentNotes(event.target.value);
  };

  const [editTeamTermNotes] = useMutation(EDIT_TEAM_TERM_NOTES);
  const handleSave = async () => {
    if (initNotes === currentNotes) {
      handleClose();
      return;
    }
    const { loading, data, error } = await editTeamTermNotes({
      variables: {
        teamTermId: parseInt(teamTermId),
        notes: currentNotes,
      },
    });
    if (error) {
      alert("Unfortunately an error occurred.");
    } else if (data && data.editTeamTermNotes) {
      handleClose();
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "100%",
              maxWidth: "600px",
              maxHeight: "500px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 0,
          }}
        >
          <Box mt={1} ml={1}>
            Team Sprint Notes
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box style={{ width: "fit-content" }}>
              <Typography
                variant="h1"
                style={{
                  fontSize: 15,
                  padding: 5,
                  // marginBottom: "2rem",
                  // marginLeft: ".3rem",
                  color: "#000",
                }}
              >
                Team: {teamName}
              </Typography>
              <Typography
                variant="h1"
                style={{
                  fontSize: 15,
                  padding: 5,
                  marginBottom: "2rem",
                  marginLeft: ".1rem",
                  color: "#000",
                }}
              >
                Sprint: {termName}
              </Typography>
              <TextField
                id="teamTermNotes"
                variant="outlined"
                multiline
                fullWidth
                autoFocus
                required
                label="Team Sprint Notes"
                margin="normal"
                name="teamTermNotes"
                rows={4}
                className={classes.textFieldStyle}
                defaultValue={initNotes}
                // inputProps={{
                //   maxLength: 254,
                // }}
                InputProps={{
                  classes: {
                    input: classes.textFieldInput,
                  },
                }}
                onChange={handleChange}
              />
            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center", marginTop: 15 }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
